import { gql } from "@apollo/client";

export const FETCH_PRODUCTS_FOR_FCST = gql`
  query FETCH_PRODUCTS_FOR_FCST($mode: String, $forecastCategoryId: ID) {
    products: salesGetProductsForFcst(mode: $mode) {
      id
      odooId
      name
      number
      countryCodeOfOrigin
    }
    salesGetForecast(mode: $mode, forecastCategoryId: $forecastCategoryId)
  }
`;

export const FETCH_FCST_META = gql`
  query FETCH_FCST_META {
    salesGetForecast(mode: "ALL")
  }
`;

export const FETCH_SUBMISSION_DATA = gql`
  query FETCH_SUBMISSION_DATA(
    $mode: String!
    $company: String!
    $warehouse: String!
  ) {
    products: salesGetProductsForFcst(mode: $mode) {
      id
      odooId
      name
      number
      cbm: outerCartonCbm
      itemsPerSet
      countryCodeOfOrigin
    }
    salesGetDraftSubmission(company: $company, warehouse: $warehouse) {
      id
      company
      warehouse
      data
      createdAt
      updatedAt
      submittedAt
    }
    lastSubmission: salesGetLatestSubmission(
      company: $company
      warehouse: $warehouse
    ) {
      id
      company
      warehouse
      data
      createdAt
      updatedAt
      submittedAt
    }
  }
`;

export const FETCH_PETE_FCST = gql`
  query FETCH_PETE_FCST($sheetName: String!) {
    salesPeteForecast(sheetName: $sheetName)
  }
`;

export const SAVE_FORECAST_SUBMISSION = gql`
  mutation SAVE_FORECAST_SUBMISSION(
    $company: String!
    $warehouse: String!
    $data: String!
    $forecastCategoryId: ID
  ) {
    salesSaveForecastSubmission(
      company: $company
      warehouse: $warehouse
      data: $data
      forecastCategoryId: $forecastCategoryId
    ) {
      submission {
        id
        company
        warehouse
        data
        createdAt
        updatedAt
        submittedAt
      }
    }
  }
`;

export const SUBMIT_FORECAST = gql`
  mutation SUBMIT_FORECAST($forecastCategoryId: ID!, $data: String!) {
    salesSubmitForecast(forecastCategoryId: $forecastCategoryId, data: $data) {
      submission {
        id
      }
    }
  }
`;
